import { isEmpty } from 'check-tool';

import { db } from '../../firebase';
import { getBackendError } from 'common/utils';
import { updateCntPushNotification } from '../User';

const notificationMapper = (documentSnapshot) => {
  const { title, content, dateUpdated, number } = documentSnapshot.data();

  return {
    id: documentSnapshot.id,
    title,
    content,
    dateUpdated,
    number: number ? number : 0,
  };
};

const notificationListMapper = (docs) => {
  return docs.map((documentSnapshot) => notificationMapper(documentSnapshot));
};

export const getNotificationList = async () => {
  return new Promise((resolve, reject) => {
    db
      .collection('notification')
      .orderBy('number')
      .get()
      .then((querySnapshot) => resolve(notificationListMapper(querySnapshot.docs)))
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};


export const updateNotification = async (
  id,
  titleEn,
  titleRu,
  titleUk,
  contentEn,
  contentRu,
  contentUk,
  ) => {
  const date = new Date().getTime();
  return new Promise((resolve, reject) => {
    db
      .collection('question')
      .doc(id)
      .update({
        dateUpdated: date,
        title: {
          en: titleEn,
          ru: titleRu,
          uk: titleUk,
        },
        content: {
          en: contentEn,
          ru: contentRu,
          uk: contentUk,
        }
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const getNotificationItem = async (id) => {
  return new Promise((resolve, reject) => {
    db
      .collection('notification')
      .doc(id)
      .get()
      .then((querySnapshot) => {
        const { title, content, countSend } = querySnapshot.data();
        const obj = {
          id: querySnapshot.id,
          title,
          content,
          countSend,
        };
        resolve(obj);
      })
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const createNotification = (
  number,
  titleEn,
  titleRu,
  titleUk,
  contentEn,
  contentRu,
  contentUk,
) => {
  const date = new Date().getTime();
  return new Promise((resolve, reject) => {
    db
      .collection('notification')
      .add({
        number: parseInt(number),
        dateCreated: date,
        dateUpdated: date,
        title: {
          en: titleEn,
          ru: titleRu,
          uk: titleUk,
        },
        content: {
          en: contentEn,
          ru: contentRu,
          uk: contentUk,
        }
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const deleteNotificationItem = async (id) => {
  return new Promise((resolve, reject) => {
    db
      .collection('notification')
      .doc(id)
      .delete()
      .then(() => {
        resolve();
      })
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};


export const sendPushNotification = async (lang, users, notification) => {
  return new Promise((resolve, reject) => {
    let total = 0;
    users.forEach((value) => {
      const currentLang = value.language;
      if ((lang === 'all' || currentLang === lang) && value.cntPushNotification === notification.number && value.email === 'irina.bt@gmail.com') {
        console.log('value', value);
        const notificationData = {
          title: notification.title[currentLang],
          body: notification.content[currentLang] ? notification.content[currentLang] : '-',
          vibrate: 1,
          sound: 1,
          show_in_foreground: true,
          priority: "high",
          content_available: true,
        };
        const data = {
          title: notification.title[currentLang],
          body: notification.content[currentLang] ? notification.content[currentLang] : '-',
          score: 50,
          wicket: 1,
        };
        total++;
        sendPushNotificationFetch(value.deviceToken, notificationData, data, value.cntPushNotification);
      }
    });
    console.log('total', total);
    resolve();
  });
};

/*
  notification: {
    title: "This is a Notification",
    boby: "This is the body of the Notification",
    vibrate: 1,
    sound: 1,
    show_in_foreground: true,
    priority: "high",
    content_available: true,
  },
  data: {
    title: "This is a Notification",
    boby: "This is the body of the Notification",
    score: 50,
    wicket: 1,

  },
*/

const sendPushNotificationFetch = async (toDeviceToken, notification, data, cnt) => {
  if (!isEmpty(toDeviceToken) && toDeviceToken !== '-') {
    const FIREBASE_API_KEY =
      'AAAATQPh4MY:APA91bHgYQZctVBZJYiV6HACDM9rDBjeyfWb7Rb2Cg57pMsQIb9NHamcgKUs6j4pOl8Cd2VGXL78xYtB1OMrOvtwellUR6vP8Ti-F4fqfAf22VPDQGd_H3sRgnULBWuqnPtjc05mbR0d';
    const message = {
      to: toDeviceToken,
      notification,
      data,
      foreground: true,
    };

    let headers = new Headers({
      'Content-Type': 'application/json',
      Authorization: 'key=' + FIREBASE_API_KEY,
    });

    let response = await fetch('https://fcm.googleapis.com/fcm/send', {
      method: 'POST',
      headers,
      body: JSON.stringify(message),
    });
    response = await response.json();
    if (response.success > 0) {
      updateCntPushNotification(toDeviceToken, cnt + 1);
    }
    if (response.failure > 0) {
      console.log(response);
    }
  } else {
    console.log('cnt', cnt, toDeviceToken);
  }
};
